import * as React from 'react'

import ListItem, { ListItemProps }         from '@material-ui/core/ListItem'
import ListItemIcon                        from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction             from '@material-ui/core/ListItemSecondaryAction'
import ListItemText, { ListItemTextProps } from '@material-ui/core/ListItemText'
import { SvgIconProps }                    from '@material-ui/core/SvgIcon'
import Switch, { SwitchProps }             from '@material-ui/core/Switch'

import SelectDialog, { Option } from './SelectDialog'

import testingHooks from '../../testing-hooks'

interface SettingProps {
  listItemProps?: ListItemProps
  listItemTextProps?: ListItemTextProps
  primary: ListItemTextProps['primary']
  secondary: ListItemTextProps['secondary']
  Icon?: React.ComponentType<SvgIconProps>
  iconProps?: SvgIconProps

  selectDialogProps?: {
    onSave: (value: any) => void,
    options: Option [],
    initialSelected?: any,
  }

  switchProps?: {
    onChange: SwitchProps['onChange']
    checked: boolean
  }
}

const Setting = ({
  switchProps,
  selectDialogProps,

  Icon,
  primary,
  secondary,

  listItemTextProps,
  listItemProps,
  iconProps,
}: SettingProps) => {
  const listItemText = (
    <ListItemText
      primary={primary}
      secondary={secondary}
      inset={!Icon}
      {...listItemTextProps}
    />
  )

  const listItemIcon = Icon && (
    <ListItemIcon>
      <Icon {...iconProps} />
    </ListItemIcon>
  )

  if (selectDialogProps) {
    return (
      <SelectDialog
        {...selectDialogProps}
      >
        {({ open }) => (
          <ListItem
            onClick={open}
            data-test-id={testingHooks.settingsListItem}
            {...listItemProps}
          >
            {listItemIcon}
            {listItemText}
          </ListItem>
        )}
      </SelectDialog>
    )
  }

  if (switchProps) {
    return (
      <ListItem {...listItemProps}>
        {listItemIcon}
        {listItemText}
        <ListItemSecondaryAction>
          <Switch {...switchProps} />
        </ListItemSecondaryAction>
      </ListItem>
    )
  }

  return null
}

export default Setting



// WEBPACK FOOTER //
// ./src/components/molecules/Setting.tsx